import { ColDef } from 'ag-grid-community'
import { CurrencyCell } from 'components/core-v2'

export const COLUMN_DEFS = (nameHeading = 'Name') => [
  {
    headerName: nameHeading,
    field: 'name',
    minWidth: 130,
    flex: 0.8
  },
  {
    headerName: 'Amount',
    field: 'value',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned',
    cellRenderer: CurrencyCell({ fieldName: 'value', variant: 'full' })
  }
]

export const DEFAULT_COLUMN_DEFS: ColDef = {
  sortable: true,
  unSortIcon: true
}
